<template>
  <div class="d-flex flex-column">
    <a
      v-for="(action, index) in sortedActions"
      :key="index"
      href="#"
      @click.prevent="handleClick(action)"
      style="margin-bottom: 5px"
      class="bosch-output-action"
    >
      <span :class="getActionIcon(action)" class="mr-1"></span>
      <span>{{ action.name }}</span>
    </a>
  </div>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import { useDeviceMessages } from "./composables/useDeviceMessages";
import axios from "@axios";

export default {
  name: "BoschOutput",
  props: {
    device: Object,
    trans: Object,
    loadingToast: Object,
    updateStatus: Function,
    timeout: Number,
    source: {
      type: String,
      default: "default",
    },
  },
  setup(props) {
    const { confirmActionAlert, successAlertAction, errorAlertAction, showToast } =
      useDeviceMessages(props.trans);
    const localLoading = ref(false);

    const sortedActions = computed(() => {
      if (!props.device.actions) return [];

      return [...props.device.actions].sort((a, b) => {
        const actionOrder = { 'On': 1, 'Off': 2 };
        return (actionOrder[a.name] || 99) - (actionOrder[b.name] || 99);
      });
    });

    const getActionIcon = (action) => {
      const iconMap = {
        'On': 'feather icon-power text-success',
        'Off': 'feather icon-power text-danger',
      };

      return iconMap[action.name] || 'feather icon-cpu text-info';
    };

    const handleClick = async (action) => {
      const result = await confirmActionAlert(props.device, action);

      if (!result.isConfirmed) return;

      localLoading.value = true;
      showToast(props.device.status, props.device, props.loadingToast);

      try {
        const urlAction = action.data.url;

        await axios.get(urlAction);

        props.updateStatus();

        successAlertAction(props.device, action);

        setTimeout(() => {
          if (props.updateStatus) {
            props.updateStatus();
          }
        }, props.timeout);
      } catch (error) {
        console.error(
          `error in request for device ${props.device.text}:`,
          JSON.stringify(error)
        );
        errorAlertAction(props.device.status, error.response?.data?.message);
      } finally {
        localLoading.value = false;
        if (props.loadingToast) props.loadingToast.close();
      }
    };

    return {
      handleClick,
      localLoading,
      sortedActions,
      getActionIcon
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";
.bosch-output-action {
  .dark-layout & {
    color: $theme-dark-headings-color;
    &:hover {
      color: $theme-dark-label-color;
    }
  }
}
</style>
